function loadItems(button) {
  const totalPages = parseInt(
    document.querySelector("[data-total-pages]").value,
    10
  );
  let currentPage = parseInt(
    document.querySelector("[data-current-page]").value,
    10
  );

  currentPage = currentPage + 1;

  // Get the current nextUrl from the page (may contain phcursor or page=)
  let nextUrl = document.querySelector("[data-next-url]").value;
  // Replace the page number in URL to the currentPage
  nextUrl = nextUrl.replace(/page=[0-9]+/, "page=" + currentPage);

  // Disable button and add loading class
  button.setAttribute("disabled", "");
  button.classList.add("loading");

  fetch(nextUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, "text/html");

      // Extract new product items
      const newItems = doc.querySelector(".load-more-grid").innerHTML;

      // Append new items to current page
      document.querySelector(".load-more-grid").insertAdjacentHTML("beforeend", newItems);

      colorSwatches();

      // Extract the updated nextUrl (with updated phcursor or page) from the AJAX response
      const newNextUrlInput = doc.querySelector(".infinite-scroll__data input[data-next-url]");
      if (newNextUrlInput) {
        const newNextUrl = newNextUrlInput.value;

        // Update the nextUrl input on the current page with the new URL
        const scrollData = document.querySelector(".infinite-scroll__data");
        if (scrollData) {
          const nextUrlInput = scrollData.querySelector("input[data-next-url]");
          if (nextUrlInput) {
            nextUrlInput.value = newNextUrl;
            nextUrlInput.dataset.nextUrl = newNextUrl;
          }
        }
      }
    })
    .catch((error) => {
      console.error("Error loading items:", error);
      button.removeAttribute("disabled");
      button.classList.remove("loading");
    })
    .finally(() => {
      // Update current page input and remove button if last page
      if (currentPage <= totalPages) {
        const scrollData = document.querySelector(".infinite-scroll__data");
        if (scrollData && currentPage !== totalPages) {
          const currentPageInput = scrollData.querySelector("input[data-current-page]");
          if (currentPageInput) {
            currentPageInput.value = currentPage;
            currentPageInput.dataset.currentPage = currentPage;
          }

          checkVisibility();
        }

        button.removeAttribute("disabled");
        button.classList.remove("loading");

        if (currentPage === totalPages) {
          button.remove();
        }
      }
    });
}

function checkVisibility() {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
}

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
